<template>
  <v-data-table
    :headers="headers"
    :items="toolsOnSite"
    :items-per-page="500"
    item-key="id"
    disable-sort
    hide-default-footer
  >
    <template v-slot:item.image="{ item }">
      <div class="py-1">
        <v-img :src="item.image" width="50" height="50" contain />
      </div>
    </template>
    <template v-slot:item.title="{ item }">
      <div>
        {{ item.title }}
      </div>
      <div>
        <span class="caption green--text text--darken-4"
          >Value: ${{ item.unitPrice }}</span
        >
      </div>
      <div v-if="item.rentalAmountOnSite > 0">
        <span class="caption red--text text--darken-4"
          >Rented Qty: {{ item.rentalAmountOnSite }}</span
        >
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "tos-table",
  props: ["toolsOnSite"],
  data() {
    return {
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "image",
          width: 50,
        },
        { text: "Title", value: "title" },
        {
          text: "Qty On Site",
          value: "totalQty",
          align: "center",
          width: "100",
        },
      ],
    };
  },
};
</script>
